import styled from "styled-components"
import { ShareAppData } from "./Share"
import QRCode from "react-qr-code"

type Props = {
  shareAppData: ShareAppData
}

const QRCodeOnly = (props: Props) => {
  const { shareAppData } = props

  return (
    <Wrapper>
      <div className="qr">
        {true ? (
          <>
            <h1 className="text">
              View Your <span>favourites at home</span>
              <span>
                Scan the QR code to see you favourite units on your device.
              </span>
            </h1>

            <QRCode
              id="qr"
              size={160}
              value={shareAppData.shareAppURL}
              viewBox={`0 0 256 256`}
              level="L"
              fgColor="var(--secondary)"
              bgColor="var(--primary)"
            />
          </>
        ) : (
          <div className="no-qr">
            QR Code <span>is waiting</span>
          </div>
        )}
      </div>
    </Wrapper>
  )
}

export default QRCodeOnly

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .close-button {
    position: absolute;
    top: 0;
    left: 0;
    margin: 2rem;
    border-radius: 5px;
    background-color: var(--secondary);
  }

  .form {
    height: 100%;
    width: 70%;
    padding: 3em;
    display: flex;
    border-right: 1px solid #fff;
  }

  .qr {
    background-color: var(--primary);
    border: 2px solid var(--accent);

    .text {
      font-size: 5em;
      color: var(--secondary);
      opacity: 0.75;
      font-weight: 900;
      text-transform: uppercase;
      line-height: 0.7;

      & span {
        font-family: secondaryFont;
        line-height: 1;
        color: var(--accent);
        font-weight: 400;
        display: block;
        text-transform: lowercase;

        &:last-child {
          font-family: primaryFont;
          color: var(--secondary);
          font-size: 0.3em;
          font-weight: 200;
          text-transform: none;
          margin-top: 1em;
        }
      }
    }
  }

  .no-qr {
    display: flex;
    flex-direction: column;
    text-transform: uppercase;
    color: #fff;
    font-size: 1.5em;
    letter-spacing: 0.2em;
    line-height: 0.9;

    span {
      font-size: 0.8em;
      color: var(--accent);
      text-transform: lowercase;
      font-family: secondaryFont;
      text-align: right;
      margin-right: -2em;
      font-size: 2em;
    }
  }
`
